import { toBuildingSelectItem } from '../../Building'
import { toUserSelectItem } from '../../User'

import {
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING,
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
} from './DocFlowAddRecipientFields.constants'

export function isRecipientValue({ edit, values }) {
  return edit
    ? !!values[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]
    : values[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT].length > 0
}

export function getDocFlowAddRecipientFieldsEditInitialValues(item) {
  const recipient = item[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]

  return {
    [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING]:
      item[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING].length > 0
        ? toBuildingSelectItem(
            item[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING][0]
          )
        : null,
    [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]: recipient
      ? toUserSelectItem(recipient)
      : null,
  }
}
